export function initialLaunchIntent(locationLike = globalThis.location) {
  const parameters = new URLSearchParams(String(locationLike?.search || ''));
  const joinCode = parameters.get('join') || '';
  if (joinCode) return { view: 'join', joinCode };

  // Navigation only. Room authority is issued and checked by the server.
  if (parameters.get('director') === 'create') return { view: 'create', joinCode: '' };
  const view = parameters.get('view');
  if (['join', 'room', 'library', 'practice', 'script', 'editor', 'history', 'settings'].includes(view)) return { view, joinCode: '' };
  return { view: 'home', joinCode: '' };
}

export function viewUrl(view, locationLike = globalThis.location, context = {}) {
  const url = new URL(locationLike.href);
  url.searchParams.delete('director');
  url.searchParams.delete('join');
  url.searchParams.delete('view');
  url.searchParams.delete('scenario');
  url.searchParams.delete('for');
  url.searchParams.delete('saved');
  if (view === 'create') url.searchParams.set('director', 'create');
  else if (view !== 'home') url.searchParams.set('view', view);
  if (context.scenario) url.searchParams.set('scenario', context.scenario);
  if (view === 'create' && context.saved) url.searchParams.set('saved', '1');
  if (context.for === 'practice') url.searchParams.set('for', 'practice');
  return `${url.pathname}${url.search}${url.hash}`;
}
